"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeNotification = exports.showNotification = exports.requestNotificationsPermission = exports.getNotificationsPermission = exports.terminateNotifications = exports.initializeNotifications = void 0;
const notification_support_1 = require("./notification-support");
const notification_callback_1 = require("./notification-callback");
const uuid_1 = require("uuid");
// The native binary will be loaded lazily to avoid any possible crash at start
// time, which are harder to trace.
let _nativeModule = undefined;
function getNativeModule() {
    if (_nativeModule !== undefined) {
        return _nativeModule;
    }
    _nativeModule = notification_support_1.supportsNotifications()
        ? require('../build/Release/desktop-notifications.node')
        : null;
    return _nativeModule;
}
/** Initializes the desktop-notifications system. */
exports.initializeNotifications = opts => { var _a; return (_a = getNativeModule()) === null || _a === void 0 ? void 0 : _a.initializeNotifications(notification_callback_1.notificationCallback, opts); };
/** Terminates the desktop-notifications system. */
exports.terminateNotifications = () => { var _a; return (_a = getNativeModule()) === null || _a === void 0 ? void 0 : _a.terminateNotifications(); };
/** Gets the current state of the notifications permission. */
exports.getNotificationsPermission = () => { var _a; return (_a = getNativeModule()) === null || _a === void 0 ? void 0 : _a.getNotificationsPermission(); };
/** Requests the user to grant permission to display notifications. */
exports.requestNotificationsPermission = () => { var _a; return (_a = getNativeModule()) === null || _a === void 0 ? void 0 : _a.requestNotificationsPermission(); };
/**
 * Displays a system notification.
 * @param title Title of the notification
 * @param body Body of the notification
 * @param userInfo (Optional) An object with any information that needs to be
 * passed to the notification callback when the user clicks on the notification.
 * @returns The ID of the notification displayed. This ID can be used to close
 * the notification.
 */
exports.showNotification = (...args) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const id = uuid_1.v4();
    try {
        yield ((_a = getNativeModule()) === null || _a === void 0 ? void 0 : _a.showNotification(id, ...args));
    }
    catch (e) {
        return null;
    }
    return id;
});
/** Closes the notification with the given ID. */
exports.closeNotification = (...args) => { var _a; return (_a = getNativeModule()) === null || _a === void 0 ? void 0 : _a.closeNotification(...args); };
//# sourceMappingURL=native-module.js.map